import React from 'react';
import '../McmvForm.css';
import './Landing.css';

interface LandingBlogProps {
  onShowLogin: () => void;
  onShowRegister: () => void;
  onShowConsulta: () => void;
}

const LandingBlog: React.FC<LandingBlogProps> = ({ onShowLogin, onShowRegister, onShowConsulta }) => {
  return (
    <div className="landing">
      {/* Cabeçalho com logos (reutiliza o grid já existente) */}
      <div className="landing-header">
        <div className="header-logos-grid">
          <div className="logo-cell left">
            <img
              src="/images/logo-prefeitura.png"
              alt="Prefeitura de José de Freitas"
              className="header-logo"
            />
          </div>
          <div className="logo-cell center">
            <img
              src="/images/logo-mcmv.png"
              alt="Programa MCMV"
              className="header-logo"
            />
          </div>
          <div className="logo-cell right">
            <img
              src="/images/logo-secretaria.jpg"
              alt="Secretaria Municipal de Assistência Social e Cidadania"
              className="header-logo"
            />
          </div>
        </div>
      </div>

      {/* Herói com chamada para ação */}
      <section className="hero">
        <div className="hero-content">
          <h1>Minha Casa Minha Vida — José de Freitas</h1>
           <div className="hero-actions">
            <button className="btn btn-primary" onClick={onShowLogin}>Entrar</button>
            <button className="btn btn-primary" onClick={onShowRegister}>Cadastrar-se</button>
            <button className="btn btn-primary" onClick={onShowConsulta}>Consulta/Recurso Inscrição</button>
            
          </div>
        </div>
      </section>

      {/* Edital em destaque */}
      <section id="edital" className="section white-card">

 <h2>Lista de Classificados</h2>
        <div className="edict-actions">
          <a
             href="/files/CLASSIFICADOS 13022026.pdf"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Classificados  (PDF)
          </a> 
          <a
             href="/files/AVISO-DE-DIVULGACAO-DA-LISTA-FINAL-DE-CLASSISFICADOS 13022026.pdf"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aviso de divulgação  (PDF)
          </a> 
        </div>
        
        <h2>Lista Aptos e Não Aptos</h2>
        <div className="edict-actions">
          <a
             href="/files/aptos_ 22012026_.pdf"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aptos  (PDF)
          </a> 
          <a
             href="/files/nao_aptos_22012026_.pdf"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Não Aptos  (PDF)
          </a> 
        </div>
        
        <h2>Ajuste no Cronograma </h2>
        <div className="edict-actions">
          <a
             href="/files/mcmv_jf_mudanca_cronograma.pdf"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Baixar  (PDF)
          </a> 
        </div>

        <h2>Edital </h2>
        <p>Leia atentamente o edital para conhecer requisitos, prazos e documentação necessária.</p>
        <div className="edict-actions">
          <a
            href="/files/edital-jf-mcmv.pdf"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Baixar Edital (PDF)
          </a>
          <a
            href="#faq"
            className="btn btn-outline"
          >
            Perguntas Frequentes
          </a>
        </div>
        
      </section>

      {/* Cronograma */}
      

      {/* Requisitos */}
        

      {/* FAQ */}
      <section id="faq" className="section white-card">
        <h2>Perguntas Frequentes</h2>
        <div className="faq-list">
          <details>
            <summary>Quem pode participar?</summary>
            <p>Moradores de José de Freitas que se enquadram nas faixas do MCMV.</p>
          </details>
          <details>
            <summary>Como acompanho minha inscrição?</summary>
            <p>Use o número de inscrição gerado no cadastro e acesse a consulta.</p>
          </details>
          <details>
            <summary>Quais documentos são necessários?</summary>
            <p>RG, CPF, comprovantes de renda e residência, entre outros previstos no edital.</p>
          </details>
        </div>
      </section>

      {/* Rodapé */}
      <footer className="landing-footer">
        <p>-</p>
       
      </footer>
    </div>
  );
};

export default LandingBlog;